export default __webpack_public_path__ + "static/media/documents@2x.bc6da6c0.png";